import React from 'react';
import {
    DetailsGeneralFields,
    DetailsCompanyInfoFields,
    DetailsUrlsFields,
    WhiteLabelFields,
} from './DetailsFields';
import MultinationalTabs from '../../../../../components/MultinationalTabs/MultinationalTabs';

export default function DetailsTable({
    client,
    countries,
    generalData,
    excludedCodes,
}) {
    return (
        <>
            <DetailsGeneralFields data={client} generalData={generalData} />
            <h2 className="table-top-pannel__title table-top-pannel__title--indent-bottom-24px ">
                White label
            </h2>
            <WhiteLabelFields
                data={generalData?.white_label_colors}
                criiptoButtonsStyles={generalData?.criipto_buttons_styles}
                theme={client?.theme}
            />
            <h2 className="table-top-pannel__title table-top-pannel__title--indent-bottom-24px ">
                Company info
            </h2>
            <MultinationalTabs
                codeType="countries"
                excludedCodes={excludedCodes}
            >
                <DetailsCompanyInfoFields
                    data={countries}
                    generalData={generalData}
                />
            </MultinationalTabs>
            <h2 className="table-top-pannel__title table-top-pannel__title--indent-bottom-24px ">
                URLs
            </h2>
            <MultinationalTabs
                codeType="countries"
                excludedCodes={excludedCodes}
            >
                <DetailsUrlsFields
                    client={client}
                    data={generalData?.countries_localizations}
                />
            </MultinationalTabs>
        </>
    );
}
